<template>
  <v-dialog v-model="intDialogVisible" max-width="1000px" class="addValueModal addComment" scrollable attach="body">
    <NewValueModal :dialogVisible='dialogNewGroup' @close="dialogNewGroup=false" @newValueIsProposed="setNewGroup($event)" formName="Create a new group" placeholder="Group Name"></NewValueModal>

    <v-card>
      <div class="close" @click="close">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.85219 2.15L7.80219 7.1L12.7522 2.15C12.9522 1.95 13.2622 1.95 13.4622 2.15C13.6622 2.35 13.6622 2.66 13.4622 2.86L8.51219 7.8L13.4622 12.75C13.6622 12.95 13.6622 13.26 13.4622 13.46C13.2622 13.66 12.9522 13.66 12.7522 13.46L7.80219 8.51L2.85219 13.46C2.65219 13.66 2.34219 13.66 2.14219 13.46C1.94219 13.26 1.94219 12.95 2.14219 12.75L7.10219 7.8L2.15219 2.85C1.95219 2.66 1.95219 2.34 2.15219 2.15C2.34219 1.95 2.66219 1.95 2.85219 2.15Z" fill="#0A2071"/>
        </svg>

      </div>
      <v-card-title>
        <div class="titleAndFav">
              <span class="cardTitle">{{$t('Create a new criteria')}}</span>
              <v-img :src="require('@/assets/fav.svg')" alt="" v-if="criteria.is_fav == true" @click="criteria.is_fav = false;"></v-img>
              <v-img :src="require('@/assets/notfav.svg')" alt="" v-if="criteria.is_fav == false" @click="criteria.is_fav = true;"></v-img>

        </div>
        <div class="includeInAssessment">
          <div class="selectIt">
            <label>
              <input type="checkbox" v-model="includeInAssessment" >
              <span>{{$t('Include in the assessment')}}</span>
            </label>
          </div>
        </div>



      </v-card-title>
      <v-card-text>
        <div class="row ">
          <div class="col-12 col-lg-6 someCriteriaFieldContainer">
            <div class="zone_input" >
              <div class="zone_input_header">
                <span class="zone_input_name">{{ $t("Criteria name")}}*</span>
              </div>
              <input type="text"  :placeholder='$t("ex. Execution readiness")' maxLength="30" class="innopearl_input_crit" v-model="criteria.name">
            </div>
          </div>
          <div class="col-12 col-lg-6 someCriteriaFieldContainer">
            <div class="zone_input" >
              <div class="zone_input_header">
                <span class="zone_input_name">{{ $t("Group")}}*</span>

              </div>
              <v-select
                 v-model="criteria.group"
                 :items="groups"

                 item-title="name"
                 item-value="_id"
                 :label='$t("Select a group*")'
                 multiple
                 chips
                 closable-chips=true
                 class="custom-select"
               ></v-select>

               <button class="prev_step_btn_crit" type="button" @click="dialogNewGroup = true" name="button">
                 <v-img :src="require('@/assets/plusCriteria.svg')" alt=""></v-img>
                 {{ $t("Add new group")}}
               </button>
            </div>
          </div>
        </div>
        <div class="row ">
            <div class="col-12 someCriteriaFieldContainer">
              <div class="zone_input" >
                <div class="zone_input_header">
                  <span class="zone_input_name">{{ $t("Description")}}*</span>
                </div>

                <textarea :placeholder='$t("Explain the criteria to judges")' class="" v-model="criteria.description"></textarea>
              </div>
            </div>
        </div>
        <div class="row ">
            <span class="zone_input_name ratingValueexplanation">Rating value explanation
              <v-img :src="require('@/assets/infoCriteria.svg')" alt=""></v-img>
              <div class="infoBox">
                {{ $t("High value = favorable assessment") }}
              </div>
            </span>
            <div class="ratingContaienr someCriteriaFieldContainer">


              <div class="col-12 ">
                <div class="zone_input" >
                  <div class="zone_input_header">
                    <span class="zone_input_name">{{ $t("Rating 1")}}</span>
                  </div>
                  <input type="text"  :placeholder='$t("very low -  counts as 1 point")' maxLength="30" class="innopearl_input_crit" v-model="criteria.rating_1">
                </div>
              </div>
              <div class="col-12">
                <div class="zone_input" >
                  <div class="zone_input_header">
                    <span class="zone_input_name">{{ $t("Rating 2")}}</span>
                  </div>
                  <input type="text" :placeholder='$t("low - counts as 2 points")' maxLength="30" class="innopearl_input_crit" v-model="criteria.rating_2">
                </div>
              </div>
              <div class="col-12">
                <div class="zone_input" >
                  <div class="zone_input_header">
                    <span class="zone_input_name">{{ $t("Rating 3")}}</span>
                  </div>
                  <input type="text"  :placeholder='$t("medium - counts as 3 points")' maxLength="30" class="innopearl_input_crit" v-model="criteria.rating_3">
                </div>
              </div>
              <div class="col-12">
                <div class="zone_input" >
                  <div class="zone_input_header">
                    <span class="zone_input_name">{{ $t("Rating 4")}}</span>
                  </div>
                  <input type="text"  :placeholder='$t("high - counts as 4 points")' maxLength="30" class="innopearl_input_crit" v-model="criteria.rating_4">
                </div>
              </div>
              <div class="col-12">
                <div class="zone_input" >
                  <div class="zone_input_header">
                    <span class="zone_input_name">{{ $t("Rating 5")}}</span>
                  </div>
                  <input type="text"  :placeholder='$t("very high - counts as 5 points")' maxLength="30" class="innopearl_input_crit" v-model="criteria.rating_5">
                </div>
              </div>
                        </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <button class="cancelBtn" @click="close" >
          {{$t("CancelCriteriaCreateDialog")}}
        </button>
        <button class="confirmBtn" @click="submit" >
            {{$t("ConfirmCriteriaCreateDialog")}}
        </button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/tools/api';
 import { toast } from 'vue-sonner'
  import NewValueModal from '@/components/modals/addValue.vue'

export default {
  components: {
     NewValueModal,
  },
  props: {
    dialogVisible: Boolean,
    formName: String,
  },
  data () {
    return{
      dialogNewGroup:false,
      groups:[],
      criteria:{
        name:"",
        group: [],
        description:"",
        rating_1: "Very low",
        rating_2:"Low",
        rating_3:"Medium",
        rating_4: "High",
        rating_5:"Very high",
        is_fav:false,

      },
      includeInAssessment:true,
    }
  },
  methods:{
    setNewGroup(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/addCriteriaGrpup",
        { group : {
          name : v
        }},
        { headers: {'Content-Type': 'application/json',}}
      ).then( (r) => {
          console.log("dfqsd",r.data);
          this.groups.push(r.data);
          this.dialogNewGroup = false;
        }).catch( () => {
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
      }
    },
    submit(){
      var error = false;
      if(!this.criteria.name){
        toast.error(this.$t("PLEASE provide criteria name TO proceed"));
        error = true;
      }
      if(!this.criteria.group){
        error = true;
            toast.error(this.$t("PLEASE select a group TO proceed"));
      }
      if(this.criteria.group.length == 0){
        error = true;
            toast.error(this.$t("PLEASE select a group TO proceed"));
      }
      if(!this.criteria.description){
        error = true;
        toast.error(this.$t("PLEASE provide criteria description TO proceed"));
      }
      if(!error){
        api.post(process.env.VUE_APP_API_URL+"/restrict/addCriteria",
        { criteria : this.criteria},
        { headers: {'Content-Type': 'application/json',}}
      ).then( (r) => {
          console.log("dfqsd",r.data);
              this.$emit('newCriteriaCreated',{
                insertedCriteria : r.data,
                includeInAssessment : this.includeInAssessment
              }
              )
        }).catch( () => {
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
      }
    },
    close(){
        this.$emit('close',false)
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    }
  },
  watch: {
    dialogVisible: function(){
      this.criteria = {
        name:"",
        group: [],
        description:"",
        rating_1: "",
        rating_2:"",
        rating_3:"",
        rating_4: "",
        rating_5:"",
        is_fav:false
      };
      this.includeInAssessment= true;
      //if(this.dialogVisible == true){
        api.get(process.env.VUE_APP_API_URL+"/restrict/mygroupsofcriterias").then( (r) => {
          console.log("dfqsd",r.data);
          this.groups = r.data;
        });
      //}
    }
  }

}
</script>

<style media="screen" scoped>

.prev_step_btn_crit,
.prev_step_btn_crit:hover{
  border: 1px solid rgba(57, 130, 196, 1);
  border-radius: 50px;
  opacity: 1;
  padding: 10px 30px;
  color:rgba(57, 130, 196, 1);
font-size:16px;
    text-decoration: none;
    margin-top:20px;
  display:flex;
  gap:10px;
  margin-left: auto;
}
.zone_input_icon{
  width: 55px;
}
.zone_input_name{
  text-align: left;
  font-size: 15px;
  line-height: 21px;
  color: rgba(4,36,106);
  font-weight: 600;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  align-items: center;
  position:relative;
  margin-bottom:10px;
}
.mt20{
  margin-top: 20px;
}
.innopearl_input_crit{
  border: 1px solid #DDDDDD;
border-radius: 8px;
box-sizing: border-box;
height: 40px;
padding: 5px;
width:100%;
margin:0px;
}
@media screen and (max-width: 990px){
.innopearl_input_crit{
  width:100%;
  margin-left:0;
}
}

textarea{
  border: 1px solid #DDDDDD;
border-radius: 8px;
width: calc(100% );

padding: 5px;
 resize: none;

}
.someCriteriaFieldContainer{
  margin-bottom:25px;
}
.ratingContaienr{
  display:flex;
  flex-direction: column;
  gap:15px;
  margin-top:10px;
}
.ratingValueexplanation{
  display:flex;
  gap:10px;
  position:relative;
}
.ratingValueexplanation .v-img{
  width:14px;
  flex: none;
}

.infoBox{
  position: absolute;
  bottom: -5px;
  left: 10px;
  transform: translateY(100%);
  box-shadow: 0px 4px 12px 2px rgba(0, 0, 0, 0.12);
  padding: 10px;
  background: #FFF;
  z-index: 99;
  display:none;
}

.ratingValueexplanation .v-img:hover ~ .infoBox{
  display:block;
}
.titleAndFav {
  display:flex;
  gap:10px;
}
.titleAndFav .v-img{
  width:20px;
  flex:none;
}
.v-card-title{
  padding-top:20px;
  padding-bottom: 20px;
  padding-right:75px;
  border-bottom:1px solid #EFEFEF;
  display:flex;
  align-items: space-between;
  align-items: center;
  justify-content: space-between;
}

@media screen and (max-width:990px){
  .v-card-title{
    flex-direction: column;
  }
}
.selectIt label{
font-size:15px;
font-weight: 600;
color:rgba(4, 36, 106, 1);
display:flex;
align-items: center;
gap: 5px;
}
.selectIt input{
  width:14px;
  height:14px;
}

.cancelBtn{
padding: 10px 24px 10px 24px;
color:rgba(57, 130, 196, 1);
border:1px solid rgba(57, 130, 196, 1);
font-size:16px;
border-radius:50px;

}

.confirmBtn{
padding: 10px 24px 10px 24px;
background:rgba(57, 130, 196, 1);
color:#FFF;
border:1px solid rgba(57, 130, 196, 1);
font-size:16px;
border-radius:50px;

}
.v-card-actions{
  padding:20px;
  gap:20px;

}

.close{
  position:absolute;
  right:20px;
  top:20px;
  cursor:pointer;
}
</style>
<style media="screen">
.custom-select .v-input__control {
border: 1px solid #e0e0e0;
border-radius: 5px;
height: 45px;
}

.custom-select .v-select__selections {
font-style: italic;
color: #9e9e9e;
}

.custom-select .v-input__append-inner .v-icon {
color: #9e9e9e;
}


.custom-select .v-field__field{
  padding-left:5px;
}

.custom-select .v-field {
  --v-field-padding-start: 10px;
  --v-field-padding-end: 10px;
  --v-field-padding-top: 0;
  --v-field-padding-bottom: 0px;

}
.custom-select .v-input__details{
  min-height:0px;
}
.custom-select .v-input__details .v-messages{
  min-height:0px;
}
.custom-select.v-input--horizontal{
  display:block;
  width:100%;
}
.custom-select .v-field__input{
  margin-top:7px;
}
.custom-select .v-field__overlay{
  display:none;
}
.custom-select .v-field__outline{
  display:none;
}
.custom-select  .v-field.v-field--active .v-label.v-field-label--floating{
  display:none;
}
</style>
